import React from 'react';
import { SvgIcon } from '@noths/polaris-client-ribbons-design-system';

import { EXPANDING_BUTTON__BUTTON_CLASS, EXPANDING_BUTTON__CONTAINER_CLASS } from '.';
import { Button } from 'src/components/atoms/Button';
import { getIconPath } from 'src/utils';
import * as styles from './styles';

export interface Props {
  controls: string;
  isExpanded: boolean;
  toggleExpanded: () => void;
}

const CHEVRON_DOWN = getIconPath('icons-16-chevron-down.svg');
const CHEVRON_UP = getIconPath('icons-16-chevron-up.svg');

export const ExpandableReadMoreButton = ({ controls, isExpanded, toggleExpanded }: Props) => (
  <div css={styles.expandingButtonContainer} className={EXPANDING_BUTTON__CONTAINER_CLASS}>
    <Button
      aria-controls={controls}
      aria-expanded={isExpanded}
      className={EXPANDING_BUTTON__BUTTON_CLASS}
      css={styles.expandingButton}
      onClick={toggleExpanded}
    >
      <SvgIcon height={16} width={16} src={isExpanded ? CHEVRON_UP : CHEVRON_DOWN} />
      <span css={styles.readMoreButtonText}>Read {isExpanded ? 'less' : 'more'}</span>
    </Button>
  </div>
);
